import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { USER_LOCAL_STORAGE_KEY } from 'app.config';

export const loggedInGuard: CanActivateFn = () => {
  const router = inject(Router);
  const isUserLoggedIn = localStorage.getItem(USER_LOCAL_STORAGE_KEY);

  if (isUserLoggedIn) {
    router.navigate(['/']);
    return false;
  }
  return true;
};
